// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

import { ADD_APPLICATION_SETTINGS } from './types'

const initialState = fromJS({})

const applicationSettings = (state = initialState, action) => {
  switch (action.type) {
    case ADD_APPLICATION_SETTINGS :
      return state.merge(
        fromJS(action.entity)
      )

    default :
      return state
  }
}

export default applicationSettings
